// import { Modal } from "react-bootstrap";
// import { useFetchData, usePostApiRequest } from "../../../helpers/api";
// import { CustomSelect } from "../../../components/CustomSelect";
// import LoadingSpinner from "../../../components/loading/LoadingSpinner";
// import { useState } from "react";
// import toast from "react-hot-toast";

// const shapeOptions = [{ value: "ROUND", label: "ROUND" }];

// const AddModal = ({ show, onHide, formData, setFormData, defaultFormData }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const { data: diamondSizeData } = useFetchData(
//     "diamondSizeFilterModal",
//     "/Customer/GetDiamondSize",
//     { Shape: "ROUND" }
//   );
//   const postApiRequest = usePostApiRequest();

//   const onCloseModal = () => {
//     onHide();
//   };

//   const handleChange = (field, value) => {
//     setFormData((prevData) => {
//       let updatedData = { ...prevData, [field]: value };

//       const selectedSizeOption = diamondSizeData?.Data?.find(
//         (option) => option.Pointer === parseFloat(updatedData.Size)
//       );

//       const pointerValue = selectedSizeOption?.Pointer || 0;
//       const sizeCodeValue = selectedSizeOption?.SizeCode || "";

//       if (field === "Size") {
//         updatedData.SizeCode = sizeCodeValue;

//         if (
//           updatedData.NumberOfPCS &&
//           !isNaN(parseFloat(updatedData.NumberOfPCS)) &&
//           pointerValue
//         ) {
//           updatedData.CaratWeight = (
//             parseFloat(updatedData.NumberOfPCS) * pointerValue
//           ).toFixed(4);
//         } else {
//           updatedData.CaratWeight = "";
//         }
//       }

//       if (field === "NumberOfPCS") {
//         if (value === "" || isNaN(parseFloat(value))) {
//           updatedData.CaratWeight = "";
//         } else if (pointerValue) {
//           updatedData.CaratWeight = (parseFloat(value) * pointerValue).toFixed(
//             4
//           );
//         }
//       }

//       if (field === "CaratWeight") {
//         if (value === "" || isNaN(parseFloat(value))) {
//           updatedData.NumberOfPCS = "";
//         } else if (pointerValue) {
//           updatedData.NumberOfPCS = Math.round(
//             parseFloat(value) / pointerValue
//           );
//         }
//       }

//       return updatedData;
//     });
//   };

//   const saveReset = () => {
//     setFormData(defaultFormData);
//     onHide();
//   };

//   const saveStock = async () => {
//     setIsLoading(true);
//     const data = [formData];

//     try {
//       const response = await postApiRequest({
//         url: "/Customer/SaveCustomerStock",
//         method: "POST",
//         data: data,
//         queryKey: ["customerStock"],
//       });
//       if (response.Status === true) {
//         saveReset();
//         // toast.success(response.Message);
//       } else {
//         toast.error(response.Message);
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const mapOptions = (data, valueKey, labelKey) =>
//     data?.map((option) => ({
//       value: String(option[valueKey]),
//       label: option[labelKey],
//     }));

//   return (
//     <Modal
//       show={show}
//       onHide={onCloseModal}
//       className="add_stock_modal"
//       backdrop="static"
//       keyboard={false}
//     >
//       {isLoading && <LoadingSpinner />}
//       <Modal.Header closeButton>
//         <Modal.Title
//           id="contained-modal-title-vcenter"
//           style={{ fontSize: "15px" }}
//         >
//           Add My Stock
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className="input_con">
//           <CustomSelect
//             options={shapeOptions}
//             value={formData.Shape}
//             onChange={(value) => handleChange("Shape", value)}
//             placeholder="Select Shape"
//             showLabel={true}
//             labelName="Select Shape"
//           />
//         </div>
//         <div className="input_con">
//           <CustomSelect
//             options={mapOptions(diamondSizeData?.Data, "Pointer", "SizeCode")}
//             value={formData.Size ? String(formData.Size) : ""}
//             onChange={(value) => handleChange("Size", value)}
//             placeholder="Select Size"
//             showLabel={true}
//             labelName="Select Size"
//             customClass="size_custom_filter"
//           />
//         </div>
//         <div className="input_con">
//           <label htmlFor={`custom_filter_pcs`}>Number of PCS.</label>
//           <input
//             type="text"
//             value={formData.NumberOfPCS}
//             id="custom_filter_pcs"
//             name="custom_filter_pcs"
//             onChange={(e) => handleChange("NumberOfPCS", e.target.value)}
//           />
//         </div>

//         {/* Weight Input */}
//         <div className="input_con">
//           <label htmlFor={`custom_filter_carat`}>Carat Weight</label>
//           <input
//             type="text"
//             value={formData.CaratWeight}
//             id="custom_filter_carat"
//             name="custom_filter_carat"
//             onChange={(e) => handleChange("CaratWeight", e.target.value)}
//           />
//         </div>
//       </Modal.Body>
//       <Modal.Footer>
//         <button className="close_btn" type="button" onClick={onCloseModal}>
//           Cancel
//         </button>
//         <button className="submit_btn" type="button" onClick={saveStock}>
//           Save
//         </button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default AddModal;



import { Modal } from "react-bootstrap";
import { useState } from "react";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { CustomSelect } from "../../../components/CustomSelect";
import { useFetchData, usePostApiRequest } from "../../../helpers/api";
import LoadingSpinner from "../../../components/loading/LoadingSpinner";
import { MinusIcon, PlusIcon } from "../../../assets/svg/ProuductIcons";

const shapeOptions = [{ value: "ROUND", label: "ROUND" }];
const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const theKeyId = customerData?.Id ? customerData.Id : null;

const AddModal = ({ show, onHide, formData, setFormData }) => {

  const [isLoadingApi, setIsLoadingApi] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { data: diamondSizeData } = useFetchData(
    "diamondSizeFilterModal",
    "/Customer/GetDiamondSize",
    { Shape: "ROUND" }
  );
  const postApiRequest = usePostApiRequest();

  const onCloseModal = () => {
    onHide();
  };

  const addRow = () => {
    setFormData((prevData) => [
      ...prevData,
      {
        Id: prevData.length + 1,
        CustomerId: Number(theKeyId),
        Shape: "ROUND",
        Size: "",
        CaratWeight: "",
        NumberOfPCS: "",
        SizeCode: "",
      }
    ]);
  };

  const removeRow = async (index, rowId) => {
    if (rowId > 0) {
      setIsLoadingApi(true);
      try {
        const response = await postApiRequest({
          url: "/Customer/DeleteCustomerStock",
          method: "POST",
          data: { Id: rowId, CustomerId: Number(theKeyId) },
          queryKey: ["customerStock"],
          noToast: true,
        });

        if (response.Status === true) {
          setFormData((prevData) =>
            prevData.filter((_, i) => i !== index)
          );
        }
      } catch (error) {
        console.error("API call failed:", error);
        return;
      } finally {
        setIsLoadingApi(false);
      }
    } else {
      setFormData((prevData) => prevData.filter((_, i) => i !== index));
    }
  };

  // newcode 
  const handleChange = (field, value, idx) => {
    setFormData((prevData) => {
      const updatedData = [...prevData];

      const item = { ...updatedData[idx], [field]: value };

      const selectedSizeOption = diamondSizeData?.Data?.find(
        (option) => option.Pointer === parseFloat(item.Size)
      );

      const pointerValue = selectedSizeOption?.Pointer || 0;
      const sizeCodeValue = selectedSizeOption?.SizeCode || "";

      if (field === "Size") {
        item.SizeCode = sizeCodeValue;

        if (
          item.NumberOfPCS &&
          !isNaN(parseFloat(item.NumberOfPCS)) &&
          pointerValue
        ) {
          item.CaratWeight = (
            parseFloat(item.NumberOfPCS) * pointerValue
          ).toFixed(4);
        } else {
          item.CaratWeight = "";
        }
      }

      if (field === "NumberOfPCS") {
        if (value === "" || isNaN(parseFloat(value))) {
          item.CaratWeight = "";
        } else if (pointerValue) {
          item.CaratWeight = (parseFloat(value) * pointerValue).toFixed(4);
        }
      }

      if (field === "CaratWeight") {
        if (value === "" || isNaN(parseFloat(value))) {
          // optional: item.NumberOfPCS = "";
        } else if (pointerValue) {
          item.NumberOfPCS = Math.round(parseFloat(value) / pointerValue);
        }
      }

      updatedData[idx] = item;

      return updatedData;
    });
  };

  const saveReset = () => {
    setFormData([{
      Id: 0,
      CustomerId: Number(theKeyId),
      Shape: "ROUND",
      Size: "",
      CaratWeight: "",
      NumberOfPCS: "",
      SizeCode: "",
    }]);
    onHide();
  };

  const saveStock = async () => {
    if (!theKeyId || isNaN(Number(theKeyId))) {
      toast.error("Invalid or missing Customer ID. Please re-login.");
      return;
    }
    // Re-map formData to ensure CustomerId is applied correctly
    const correctedFormData = formData.map((item) => ({
      ...item,
      CustomerId: Number(theKeyId),
    }));

    if (!correctedFormData[0].CustomerId) {
      toast.error("Customer ID is missing. Please re-login.");
      return;
    }

    for (let i = 0; i < formData.length; i++) {
      const row = formData[i];
      if (!row.Size || !row.Size.trim()) {
        toast.error(`Please select Size for row ${i + 1}`);
        return;
      }
      if (!row.NumberOfPCS || !row.NumberOfPCS.trim()) {
        toast.error(`Please enter Number of PCS for row ${i + 1}`);
        return;
      }
    }

    setIsLoading(true);

    try {
      const response = await postApiRequest({
        url: "/Customer/SaveCustomerStock",
        method: "POST",
        data: correctedFormData,
        queryKey: ["customerStock"],
      });
      if (response.Status === true) {
        saveReset();
        // toast.success(response.Message);
      } else {
        toast.error(response.Message);
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const mapOptions = (data, valueKey, labelKey) =>
    data?.map((option) => ({
      value: String(option[valueKey]),
      label: option[labelKey],
    }));

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="add_stock_modal"
      backdrop="static"
      keyboard={false}
    >
      {isLoadingApi && <LoadingSpinner />}
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{ fontSize: "15px" }}
        >
          Filter With My Diamonds
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {formData.map((row, idx) => (
          <div key={idx} className="row_group">
            <div className="input_con">
              <CustomSelect
                options={shapeOptions}
                value={row.Shape}
                onChange={(value) => handleChange("Shape", value, idx)}
                placeholder="Select Shape"
                showLabel={true}
                labelName="Select Shape"
              />
            </div>
            <div className="input_con">
              <CustomSelect
                options={mapOptions(diamondSizeData?.Data, "Pointer", "SizeCode")}
                value={row.Size ? String(row.Size) : ""}
                onChange={(value) => handleChange("Size", value, idx)}
                placeholder="Select Size"
                showLabel={true}
                labelName="Select Size"
                customClass="size_custom_filter"
              />
            </div>
            <div className="input_con">
              <label htmlFor={`custom_filter_pcs_${idx}`}>Number of PCS.</label>
              <input
                type="text"
                value={row.NumberOfPCS}
                id={`custom_filter_pcs_${idx}`}
                name={`custom_filter_pcs_${idx}`}
                onChange={(e) => handleChange("NumberOfPCS", e.target.value, idx)}
              />
            </div>
            <div className="input_con">
              <label htmlFor={`custom_filter_carat_${idx}`}>Carat Weight</label>
              <input
                type="text"
                value={row.CaratWeight}
                id={`custom_filter_carat_${idx}`}
                name={`custom_filter_carat_${idx}`}
                onChange={(e) => handleChange("CaratWeight", e.target.value, idx)}
              />
            </div>
            <div className="d-flex">
              <div className="remove_row">
                {
                  formData.length > 1 && (
                    <button onClick={() => removeRow(idx, row.Id)}>
                      <MinusIcon className="addRow_icon" />
                    </button>
                  )
                }
              </div>
              <div className="addrow">
                {
                  idx === formData.length - 1 && (
                    <button onClick={addRow}>
                      <PlusIcon className="addRow_icon" />
                    </button>
                  )
                }
              </div>
            </div>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <button className="close_btn" onClick={onCloseModal} type="button">
          Cancel
        </button>
        <button className="submit_btn" onClick={saveStock} type="button">
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddModal;
